import { render, staticRenderFns } from "./RuleBuilder.vue?vue&type=template&id=489e5d10&scoped=true"
import script from "./RuleBuilder.vue?vue&type=script&lang=js"
export * from "./RuleBuilder.vue?vue&type=script&lang=js"
import style0 from "./RuleBuilder.vue?vue&type=style&index=0&id=489e5d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e5d10",
  null
  
)

export default component.exports